import React, { Component } from "react";

import { CCard, CCardHeader, CCardBody, CLabel, CButton } from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Modal,
  ModalHeader,
  Label,
  ModalBody
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentComponent from "../../../../components/Content/content";
import Loading from "../../../../components/Loading";
import CreateFilterOffline from "../../../../components/OfflineRegister/CreateFilterOffline";
import StudentPresenceTable from "../../../../components/OfflineRegister/StudentPresenceTable";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import RichText from "../../../../components/RichText/SlateEditor/Editor";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class CreateOfflineRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // continue: true,
      loading: false,
      type: 0,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      showModal: false,
      contents: [],
      disciplineList: null,
      disciplineSelected: null,
      date: null,
      // room_id: null,
      // user_id: null,
      // teacher_id: null,
      student_list: null,
      infoSelected: null,
      modalAddRegister: false,
      ValorDescricao: null,
      description: ""
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.props.setObj(16, 63, 63);
    const type = "0";
    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          types: resp.data.data,
          loading: false
          // continue: false
        });
      });

    axios
      .get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let arr = [];
        resp.data.data.forEach(item => {
          let obj = {
            value: item.id,
            label: item.name
          };
          arr.push(obj);
        });

        this.setState({
          disciplineList: arr,
          loading: false
          // continue: false
        });
      });
  }

  changeDisciplineSelected = disciplineSelected => {
    this.setState({ disciplineSelected });
  };

  getStudentList = studentList => {
    this.setState({ student_list: studentList });
  };

  removeContent = contentId => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let contentList = [...this.state.contents];
    let position;
    contentList.forEach((item, index) => {
      if (item.contentId === contentId) {
        position = index;
      }
    });
    contentList.splice(position, 1);
    this.setState({ contents: contentList });
  };

  addContent = (contentName, contentId) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    let obj = {
      contentName,
      contentId
    };
    contentList.push(obj);
    this.setState({ contents: contentList });
  };

  hideModal = hide => {
    this.setState({ showModal: !hide });
  };

  getDate = date => {
    let myDate = `${date}`;
    myDate = myDate.replaceAll("-", ".");
    let newDate = new Date(Math.floor(new Date(myDate).getTime()));
    this.setState({ date: newDate });
  };

  getInfoSelectors = (groupId, regionId, schoolId, roomId, teacherId) => {
    let obj = {
      groupId,
      regionId,
      schoolId,
      roomId,
      teacherId
    };
    this.setState({ infoSelected: obj });
  };

  setValorDescrição(val) {
    this.setState({
      ValorDescricao: val
    });
  }

  changeDescription = e => {
    let { value } = e.target;
    this.setState({
      description: value
    });
  };

  addNewRegister = addAnotherRoom => {
    let descriptionFinal = JSON.stringify(this.state.ValorDescricao);

    let studentList = [];
    this.state.student_list.forEach(item => {
      let obj = {
        student_id: item.id,
        accessed: item.status === "Presente"
      };
      studentList.push(obj);
    });

    let contentList = [];
    this.state.contents.forEach(item => {
      contentList.push(item.contentId);
    });

    let obj = {
      user_id: this.props.user.user.id,
      room_id: this.state.infoSelected.roomId,
      discipline_id: this.state.disciplineSelected.value,
      date: this.state.date,
      users: studentList,
      content: contentList,
      teacher_id: this.state.infoSelected.teacherId
    };
    axios
      .post(`${URL.api}offline/register/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(() => {
        if (!addAnotherRoom) {
          let url = "/offline/register/list";
          this.props.history.push(url);
        } else {
          this.setState({ modalAddRegister: false });
          this.disableFields;
        }
        resp => {},
          () => {
            this.error("Não foi possível adicionar o Registro Offline");
          };
      });
  };

  disableFields = () => {};

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <div className="d-flex flex-column align-items-left">
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <h4 className="card-title mb-1">Criar Registro Offline</h4>
              <div className="small text-muted">
                Crie um novo Registro Offline
              </div>
            </div>
            <div>
              <CButton
                color="primary"
                className="ml-2"
                onClick={() => {
                  this.setState({ modalAddRegister: true });
                }}
              >
                Adicionar Registro
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <CreateFilterOffline
              user={this.props.user}
              getDate={this.getDate}
              getInfoSelectors={this.getInfoSelectors}
              viewOfflineRegister={false}
            />
            <div className="myRow">
              <div className="flex-1 mb-2">
                <div className="w-100 text-ellipsis">
                  <Label className="d-block w-100 text-ellipsis">
                    Disciplina
                  </Label>
                </div>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Select
                    placeholder="Selecione a Disciplina"
                    onChange={e => this.changeDisciplineSelected(e)}
                    value={this.state.disciplineSelected}
                    options={this.state.disciplineList}
                    type="text"
                    className="flex-1"
                  />
                </InputGroup>
              </div>
              <FormGroup className="mb3 mt-3">
                <CLabel>Conteúdos</CLabel>
                <div style={{ display: "flex" }}>
                  {this.state.contents.length ? (
                    this.state.contents.map(item => (
                      <CCard className="p-2 mr-2">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>{item.contentName}</span>
                          <i
                            className="fa fa-remove"
                            onClick={() => this.removeContent(item.contentId)}
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                          ></i>
                        </div>
                      </CCard>
                    ))
                  ) : (
                    <>
                      <h4 className="text-muted mb-4">
                        Nenhum conteúdo selecionado
                      </h4>
                    </>
                  )}
                </div>
                <CButton
                  color="primary"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  Adicionar Conteúdo
                </CButton>
              </FormGroup>
              <FormGroup className="mb3 mt-3">
                <CLabel>Descrição</CLabel>
                <InputGroup>
                  <RichText
                    setValorDescricao={val =>
                      this.setState({ ValorDescricao: val })
                    }
                    description={this.state.description}
                    // eslint-disable-next-line react/jsx-boolean-value
                    editavel={true}
                  />
                </InputGroup>
              </FormGroup>
              <Modal
                isOpen={this.state.showModal}
                toggle={null}
                className={null}
                onOpened={() => this.componentDidMount()}
                size="lg"
              >
                <ModalHeader className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.setState({ showModal: false });
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </ModalHeader>
                {this.state.loading ? (
                  <div className="p-4">
                    <Loading />
                  </div>
                ) : (
                  <ContentComponent
                    type={this.state.type}
                    typeName={this.state.typeName}
                    typeIcon={this.state.typeIcon}
                    typeColor={this.state.typeColor}
                    types={this.state.types}
                    currentRoute={this.props.currentRoute}
                    serie={serie}
                    discipline={discipline}
                    isOfflineRegister
                    addContent={this.addContent}
                    hideModal={this.hideModal}
                    disciplineSelected={this.state.disciplineSelected}
                  />
                )}
              </Modal>
              <Modal
                isOpen={this.state.modalAddRegister}
                toggle={null}
                className={null}
                onOpened={() => this.componentDidMount()}
                size="lg"
              >
                <ModalHeader className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      this.setState({ modalAddRegister: false });
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </ModalHeader>
                <ModalBody>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flex: 1
                    }}
                  >
                    <h4 className="card-title mb-1">
                      Quer colocar esse mesmo conteúdo para outra turma?
                    </h4>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flex: 1
                    }}
                    className="mt-2"
                  >
                    <CButton
                      color="primary"
                      className="ml-2"
                      onClick={() => {
                        this.addNewRegister(true);
                      }}
                    >
                      Sim
                    </CButton>
                    <CButton
                      color="primary"
                      className="ml-2"
                      onClick={() => {
                        this.addNewRegister(false);
                      }}
                    >
                      Não
                    </CButton>
                  </div>
                </ModalBody>
              </Modal>
              <CLabel className="mt-2">Lista de Presença</CLabel>
              <StudentPresenceTable
                getStudentList={this.getStudentList}
                roomId={
                  this.state.infoSelected ? this.state.infoSelected : null
                }
                infoView={null}
              />
            </div>
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateOfflineRegister);
